module.exports = __webpack_public_path__ + "static/feat_intro_screen-0724adceddb3e815549c6f032a8110e1.jpg";